/**
 * Portal permission registry.
 *
 * Merges the permission modules of every registered portal app into a single
 * role → permission lookup plus the aggregate `Permissions` / `PortalRole`
 * types the rest of the app consumes.
 *
 * To onboard a new app:
 *   1. Create `src/apps/<app>/authorization` exporting an `AppPermissionModule`.
 *   2. Import its module + types below.
 *   3. Add its permissions to the `Permissions` intersection, its role union to
 *      `PortalRole`, and spread its `.roles` into `ROLES`.
 * Resource names and role strings must stay unique across apps.
 */
import { engagementLetterDatabasePermissions } from '@/apps/engagement-letter-database/authorization';
import type {
  EngagementLetterDatabasePermissions,
  EngagementLetterDatabaseRole,
} from '@/apps/engagement-letter-database/authorization';

import type { RoleLookup } from './types';

/** Every resource protected across the whole portal. */
export type Permissions = EngagementLetterDatabasePermissions;

/** Union of every Azure AD app role recognised by the portal. */
export type PortalRole = EngagementLetterDatabaseRole;

/** Merged role → permission lookup used by the permission engine. */
export const ROLES: RoleLookup<Permissions> = {
  ...engagementLetterDatabasePermissions.roles,
};
